import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: "16px 16px 0px"
			},
			header: {
				display: "flex",
				justifyContent: "space-between",
				paddingBottom: 12,
				fontSize: 14,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`
			},
			titleHeader: {
				overflow: "hidden",
				display: "inline-block",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				width: 300,
				fontWeight: 500
			},
			border: {
				width: 15,
				height: 15,
				position: "absolute",
				borderRadius: "50%",
				top: 35,
				background: theme.palette.grey["A400"]
			}
		}),
	{
		name: "HeaderLoyaltyOrder",
		index: 1
	}
);

export default useStyles;
